// @flow

import {
	TimePickerComponent,
	useTimePickerComponent,
} from "@/components/range-picker/time-picker.component";
import { TimeService, getMomentTz } from "@dexteel/mesf-core";
import { Grid, Paper } from "@material-ui/core";
import { DatePicker, StaticDatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";

type Props = {
	onChange: (date: Date) => void;
	value: Date | null;
	minDate?: Date;
	maxDate?: Date;
};

const moment = getMomentTz();

export const DateTimePickerComponent = ({
	onChange,
	value = new Date(),
	minDate,
	maxDate,
}: Props) => {
	const { state: timePickerState, actions: timePickerActions } =
		useTimePickerComponent(value);

	const [date, setStartDate] = useState<Date>(value || new Date());
	const newMinutes = timePickerState.minutes;

	useEffect(() => {
		const newValue = moment(date)
			.set({
				hours: timePickerState.hours,
				minutes: timePickerState.minutes,
				seconds: 0,
				milliseconds: 0,
			})
			.toDate();

		onChange(newValue);
	}, [date, timePickerState.hours, timePickerState.minutes]);

	return (
		<Grid container spacing={1}>
			<Grid item xs={12} container spacing={2} alignItems="stretch">
				<Grid item xs={12} md={6}>
					<Paper style={{ padding: "1rem", height: "100%" }}>
						<Grid item xs={12}>
							<DatePicker
								value={moment(value)}
								minDate={minDate ? moment(minDate) : undefined}
								maxDate={maxDate ? moment(maxDate) : undefined}
								onChange={(date, _) => {
									setStartDate(date?.toDate() || new Date());
								}}
								timezone={TimeService.getInstance().getServerTimeZone()}
								slotProps={{
									openPickerButton: {
										disabled: true,
									},
								}}
								label="Date"
							/>
						</Grid>
					</Paper>
				</Grid>

				<Grid item xs={12} md={6}>
					<Paper style={{ padding: "1rem", height: "100%" }}>
						<Grid item xs={12}>
							<span>Time</span>
						</Grid>
						<Grid item xs={12}>
							<span>
								{timePickerState.hours.toString().padStart(2, "0")}:
								{newMinutes.toString().padStart(2, "0")}
							</span>
						</Grid>
					</Paper>
				</Grid>
			</Grid>

			<Grid item xs={12} container spacing={2}>
				<Grid
					item
					xs={12}
					md={6}
					container
					justifyContent="center"
					alignItems="center"
				>
					<StaticDatePicker
						value={moment(value)}
						minDate={minDate ? moment(minDate) : undefined}
						maxDate={maxDate ? moment(maxDate) : undefined}
						onChange={(date, _) => {
							setStartDate(date?.toDate() || new Date());
						}}
						timezone={TimeService.getInstance().getServerTimeZone()}
						orientation={"landscape"}
						slotProps={{
							actionBar: {
								actions: ["today"],
							},
						}}
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<TimePickerComponent
						state={timePickerState}
						actions={timePickerActions}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};
